import { render, staticRenderFns } from "./AllergenDialog.vue?vue&type=template&id=2003ba73&"
import script from "./AllergenDialog.vue?vue&type=script&lang=js&"
export * from "./AllergenDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports